import React from 'react';

export default class UserStatus extends React.Component {
	constructor(props) {
		super(props);
	}
	
  handleLogged= ( logged, e )=> {
		this.props.setDatas({ 'logged': logged, 'init': false });
  }

  render() {
		console.dir(this.props.status)
		const isLoggedIn = this.props.status.logged;
    return (
			<>
				{
				!isLoggedIn && 
				<GuestGreeting 
					indexClass={this.props.indexClass}
				/>
				}

				{
				isLoggedIn && 
				<UserGreeting 
					onLogInChange={this.handleLogged}
					userInfo={this.props.status.logInfo}
					indexClass={this.props.indexClass}
				/>
				}
			</>

    );
	  
  }
  
}



class GuestGreeting extends React.Component {

  handlerClick= (e)=> {
		this.props.indexClass.PageLink.pageSelectEvt(e);
	}

	render () {
		return (
	  	<div className="ft-f1 flx-0">
				<a 
					href="/login" onClick={this.handlerClick} 
					className="inst-box iblock-box bg-clr-4 pd-s10 pd-h3 m-ft4">
						<div className="ft-b ft-wh">LOGIN</div>
				</a>
				<a 
					href="/join" onClick={this.handlerClick} 
					className="inst-box iblock-box bg-clr-bk mg-r10 pd-s10 pd-h3 m-ft4">
						<div className="ft-b ft-wh">JOIN</div>
				</a>
		</div>
	  );
	}
	
}



class UserGreeting extends React.Component {
	
	constructor (props) {
		super(props);
	}

  handlerClick= (e)=> {
  	this.props.indexClass.PageLink.pageSelectEvt(e);
  }

	logoutEvt= (e)=> {
		e.stopPropagation();
		e.preventDefault();
		axios.get('/users/log/LogOut')
		.then( res=> {
			this.props.onLogInChange(false);
			// localStorage.removeItem('wtw-token');
			window.location.href = '/';
			// this.props.indexClass.routing.routing('/');
		});
	}

	render () {
		return (
		  <div className="user-logged flx-0">

				<div className="user-info inst-box">
					<a 
						onClick={this.handlerClick} 
						href="/user-info" 
						className="iblock-box ft-wh bg-clr-bk pd-s10 pd-h3 m-ft4 page-link-comm"
					>
						<div className="ft-f1">
							{/* <span className="ft-bi txt-underline-under">{this.props.userInfo.userName}</span>
							<span className="ft5 ft-bi mg-l5">님 </span> */}
							<span className="">MY PAGE</span>
						</div>
					</a>

					{/* <div className="sub-user-info pd-5 bg-clr-gr">
						<a 
							onClick={this.handlerClick} 
							href="/user-info" 
							className="iblock-box ft-hv pd-s10 pd-h3 m-ft4 page-link-comm"
						>
							회원정보
						</a>

						{(this.props.userInfo.userType == '출제자' || this.props.userInfo.userType == '관리자') &&
						<a 
							onClick={this.handlerClick} 
							href="/user-quiz" 
							className="iblock-box ft-hv pd-s10 pd-h3 m-ft4 page-link-comm"
						>
							출제퀴즈
						</a>}

						
						<a 
							onClick={this.handlerClick} 
							href="/user-play-quiz" 
							className="iblock-box ft-hv pd-s10 pd-h3 m-ft4 page-link-comm"
						>
							참여퀴즈
						</a>
					</div> */}

				</div>

				<a 
					href="/api/users/LogOut" onClick={this.logoutEvt} 
					className="logout-btn inst-box iblock-box  bg-clr-4 pd-s10 pd-h3 m-ft4"
				>
					<div className="ft-wh">LOGOUT</div>
				</a>
			</div>
		);
	}
}